import React from 'react';

import {observer} from 'mobx-react';
import {GameCenterWidgetController} from "../game-center-widget.controller";
import {
  GameCenterHeaderModuleAsync
} from "../modules/game-center-header-module/components/game-center-header-module.async";
import {
  NavigationTabsModuleAsync
} from "../../../modules/navigation-tabs-module/components/navigation-tabs-module.async";
import {COMPONENT_STATES, FETCHING_STATES} from "../../../core/consts";

class GameCenterWidgetDesktopHeaderProps {
  matchupId: String;
  gameId: Number;
  location: Location;
  controller: GameCenterWidgetController;
}

export const GameCenterWidgetHeader = observer(({
                                                  controller,
                                                  matchupId,
                                                  gameId,
                                                  location,
                                                  onTabChange
                                                }: GameCenterWidgetDesktopHeaderProps) => {
  const {state} = controller;
  const {device} = state;
  const {game, currentIndex} = state;

  const baseProps = {
    matchupId,
    gameId,
    location,
    device
  };

  const tabsProps = {
    currentIndex,
    onTabChange: (index) => onTabChange && onTabChange(index),
    entity: game,
    supportArrows: true,
    isLoading: controller.state.fetchingState === FETCHING_STATES.fetching || controller.state.componentState === COMPONENT_STATES.loading
  }

  return (
    <>
      <GameCenterHeaderModuleAsync {...baseProps}/>
      <NavigationTabsModuleAsync {...tabsProps}/>
    </>
  )
});
